import IndustryActivity from "../../searchFlowVersionB/components/industryActivity/IndustryActivity.jsx";
import i18n from "../../../utils/i18n";

export {
  INDUSTRIES_WITH_ACTIVITY_CONTENT as REG_INDUSTRIES_WITH_ACTIVITY_CONTENT,
  industryHasActivityContent as regIndustryHasActivityContent,
  isIndustryActivityAnswered as isRegIndustryActivityAnswered,
} from "../../searchFlowVersionB/utils/industryActivity.js";

const RegIndustryActivity = () => (
  <IndustryActivity title={i18n.t("searchflow.regactivitytitle")} />
);

export default RegIndustryActivity;
